import React, { useState, useMemo } from 'react'
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TableFooter,
  TablePagination,
} from '@mui/material'
import { useGetStaffBenefitClaims } from '../../api/staff-benefit-claim'
import ErrorMessage from '../shared/component/ErrorMessage'
import { ClaimRow } from './ClaimRow'
import { TablePaginationActions } from '../shared/component/TablePaginationActions'

export const ClaimTable = () => {
  const { data, isLoading, error } = useGetStaffBenefitClaims()

  const staffBenefitClaims = data?.docs ?? []

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const arr = useMemo(() => {
    return rowsPerPage > 0
      ? [...staffBenefitClaims].slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : staffBenefitClaims
  }, [page, rowsPerPage, staffBenefitClaims])

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - staffBenefitClaims?.length) : 0

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      {error ? (
        <ErrorMessage error={error} />
      ) : data?.docs?.length > 0 || isLoading ? (
        <TableContainer component={Paper}>
          <Table aria-label='order table'>
            <TableHead>
              <TableRow>
                <TableCell align='left'>Order Id</TableCell>
                <TableCell align='left'>Code</TableCell>
                <TableCell align='left'>Name</TableCell>
                <TableCell align='left'>Discount</TableCell>
                <TableCell align='left'>Regional State</TableCell>
                <TableCell align='left'>Quantity</TableCell>
                <TableCell align='left'>Car Plate</TableCell>
                <TableCell align='left'>Car Model</TableCell>
                <TableCell align='left'>Supplier</TableCell>
                <TableCell align='left'>Invoice</TableCell>
                <TableCell align='left'>Status</TableCell>
                <TableCell align='left'>Validity Period</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {arr.map((row) => {
                return <ClaimRow row={row} key={row.id} />
              })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={12} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 30, { label: 'All', value: -1 }]}
                  colSpan={12}
                  count={staffBenefitClaims?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page',
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      ) : (
        <ErrorMessage empty />
      )}
    </>
  )
}
